export default __webpack_public_path__ + "static/media/pdf-resource.da3f6700.svg";